import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {I18nService} from '@services/i18n.service';
import {Subscription} from 'rxjs';
import {IdNameString, responsiveBreakpoints, ResponsiveService} from '@core/src/public-api';
import {AppConfigService} from '@shared/services/app-config.service';

@Component({
  selector: 'si-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TranslationComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  model: string;
  languageValues: IdNameString[];
  isMobileWidth: boolean;
  responsiveBreakPoints = responsiveBreakpoints;

  constructor(
    private i18nService: I18nService,
    private responsiveService: ResponsiveService,
    private appConfigService: AppConfigService
  ) {
    this.setResponsiveLogic();
    this.getLanguages();
  }

  ngOnInit(): void {
    this.model = this.i18nService.getLanguage();
  }

  async getLanguages(): Promise<void> {
    await this.appConfigService.getConfigurations();
    this.languageValues = this.i18nService.getActiveLanguageValues();
  }

  setResponsiveLogic(): void {
    this.subscriptions.push(
      this.responsiveService.getResponsiveStoreObservable().subscribe(responsiveStore => {
        this.isMobileWidth = responsiveStore.currentWindowWidth < this.responsiveBreakPoints.XS;
      })
    );
  }

  onChangeLanguage(): void {
    this.changeLanguage(this.model);
  }

  changeLanguage(langKeyLong: string): void {
    this.i18nService.setLanguage(langKeyLong);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
